import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatCheckboxModule } from "@angular/material/checkbox";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import {
  ButtonComponent,
  ButtonConfig,
  ButtonVariant,
} from "src/app/common/components/core/button/button.component";
import { WarningIconComponent } from "src/app/common/components/core/warning-icon/warning-icon.component";
import { CredentialsUpdate } from "src/app/common/interfaces/credentials-updates.interface";
import { StorageService } from "src/app/common/services/storage.service";

@Component({
  selector: "app-credential-updates",
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    ButtonComponent,
    WarningIconComponent,
  ],
  templateUrl: "./credential-updates.component.html",
})
export class CredentialUpdatesComponent implements OnInit {
  readonly continueButtonConfig: ButtonConfig = {
    text: "Continue",
    variant: ButtonVariant.PRIMARY,
  };
  formGroup!: FormGroup;
  updates!: CredentialsUpdate;
  token: string = "";
  refreshToken: string = "";
  user: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private matDialogRef: MatDialogRef<CredentialUpdatesComponent>,
    private storageService: StorageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.updates = data.updates;
  }

  ngOnInit(): void {
    const { token, refreshToken, user } = this.storageService.getAndRemoveLoginData();
    this.token = token;
    this.refreshToken = refreshToken;
    this.user = user;
    this.formGroup = this.formBuilder.group({
      confirm: [false, Validators.requiredTrue],
    });
  }

  continue(): void {
    // navigate to review attestation and signatures
    this.storageService.resetLoginData(this.token, this.refreshToken, this.user);
    this.matDialogRef.close(true);
  }

  decline(): void {
    // display some message and update eSignature Status to `Inactive-Decline`
    this.matDialogRef.close(false);
  }
}
